import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { loadPreferredOfficesStart, loadOfficesStart } from '../redux/modules/offices'
import { loadPotentialTeamsStart } from '../redux/modules/teamOnboarding'
import { loadUserTeamStart } from '../redux/modules/userTeam'
import { selectAccountsVisible } from '../redux/selectors/teamCommonSelectors'
import { selectUserTeam } from '../redux/selectors/userTeamSelectors'

const useAccounts = () => {
  const dispatch = useDispatch()
  const userTeam = useSelector(selectUserTeam)
  const locationId = useSelector(state => state?.location?.location?.deliveryLocationId)
  const showAccounts = useSelector(selectAccountsVisible)
  const isLoadingPotentialTeams = useSelector(state => state.teamOnboarding.isLoadingPotentialTeams)

  useEffect(() => {
    if (!userTeam) {
      dispatch(loadUserTeamStart())
    }
  }, [dispatch, userTeam])

  useEffect(() => {
    dispatch(loadPotentialTeamsStart())
    dispatch(loadPreferredOfficesStart())
  }, [dispatch])

  useEffect(() => {
    if (locationId !== null) {
      dispatch(loadOfficesStart(locationId))
    }
  }, [dispatch, locationId])

  return {
    showAccounts,
    isLoadingPotentialTeams,
  }
}

export default useAccounts
